/**
 * This component renders a paypalme iframe onto the success page, because we want
 * to raise visibility of paypalme at the end of the send and request flows
 */
import PropTypes from 'prop-types'

import React from 'react'
import classnames from 'classnames'

class PPMeClaimIframeComponent extends React.Component {
  static propTypes = {
    amount: PropTypes.string.isRequired,
    currencyCode: PropTypes.string.isRequired,
    intent: PropTypes.string.isRequired,
    ppmeClaimUrl: PropTypes.string.isRequired,
  }

  state = {
    iframeHasLoaded: false,
    iframeHasErrored: false,
    iframeHeight: 0,
  }

  componentDidMount() {
    let { iframe } = this.refs

    // when the iframe has loaded, we set the appropriate state, which will remove
    // the hasSpinner class and set the iframe height correctly based on content
    iframe.onload = () => {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        iframeHasLoaded: true,
        iframeHeight: iframe.contentWindow.document.body.scrollHeight,
      })
    }

    // on error set `iframeHasErrored` to true which will hide the iframe
    iframe.onerror = () => {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        iframeHasErrored: true,
      })
    }
  }

  render() {
    if (this.state.iframeHasErrored) {
      return null
    }

    const { iframeHeight, iframeHasLoaded } = this.state
    const { ppmeClaimUrl, intent } = this.props
    const fullIframeUrl = `${ppmeClaimUrl}?intent=${intent}`
    const classes = classnames('ppme-claim-widget-container', {
      hasSpinner: !iframeHasLoaded,
    })

    return (
      <div className="successBox ppmeIframeSuccessBox">
        <div id="ppmeClaimUrlWrapper" className={classes}>
          <iframe
            title="frame"
            id="ppmeClaimUrl"
            className="ppme-claim-widget-iframe"
            ref="iframe"
            style={iframeHasLoaded ? { height: `${iframeHeight}px` } : {}}
            src={fullIframeUrl}
            aria-hidden="true"
          />
        </div>
      </div>
    )
  }
}

export default PPMeClaimIframeComponent
